import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { AccountStatusProvider } from './context/AccountStatusContext';
import { ProgressBarProvider } from './context/ProgressBarContext';
import { PriceProvider } from './context/PriceContext';
import { AlertProvider, useAlert } from './context/AlertContext';
import MessageBox from './components/MessageBox';
import ProgressBar from './components/ProgressBar';
import LandingPage from './pages/preLogin/LandingPage';
import BasicDetailsPage from './pages/postLogin/BasicDetailsPage';
import MarketsPage from './pages/postLogin/MarketsPage';
import MutualFundsPage from './pages/postLogin/MutualFundsPage';
import ProfilePage from './pages/postLogin/ProfilePage';
import KycPage from './pages/postLogin/KycPage';
import AdditionalDetailsPage from './pages/postLogin/AdditionalDetailsPage';
import BankPage from './pages/postLogin/BankPage';
import ContactPage from './pages/postLogin/ContactPage';
import WatchlistPage from './pages/postLogin/WatchlistPage';
import PositionsPage from './pages/postLogin/PositionsPage';
import ReferralPage from './pages/postLogin/ReferralPage';
import AccountDetailsPage from './pages/postLogin/AccountDetailsPage';
import FundHistoryPage from './pages/postLogin/FundHistoryPage';
import SearchPage from './pages/postLogin/SearchPage';
import SymbolInfoPage from './pages/postLogin/SymbolInfoPage';
import OrderPage from './pages/postLogin/OrderPage';
import TradePage from './pages/postLogin/TradePage';
import AccountStatusPage from './pages/postLogin/AccountStatusPage';
import AllMutualFundsPage from './pages/postLogin/MutualFundList';
import MutualFundInvestPage from './pages/postLogin/MutualFundInvestPage';
import CollectionPage from './pages/postLogin/CollectionPage';
import OptionChainPage from './pages/postLogin/OptionChainPage';
import NotificationsPage from './pages/postLogin/NotificationsPage';
import SupportPage from './pages/postLogin/SupportPage';
import LegalPage from './pages/postLogin/LegalPage';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';

const GlobalAlert = () => {
  const { alert, hideAlert } = useAlert();
  return alert ? <MessageBox message={alert.message} type={alert.type} onClose={hideAlert} /> : null;
};

const AppRoutes = () => (
  <Routes>
    <Route path="/landing" element={<LandingPage />} />
    <Route path="/register" element={<Navigate to="/landing" state={{ openRegister: true }} replace />} />
    <Route path="/login" element={<Navigate to="/landing" state={{ openLogin: true }} replace />} />
    <Route path="/basic-details" element={<ProtectedRoute><Layout layoutDisabled><BasicDetailsPage /></Layout></ProtectedRoute>} />
    <Route path="/kyc" element={<ProtectedRoute><Layout layoutDisabled><KycPage /></Layout></ProtectedRoute>} />
    <Route path="/additional-details" element={<ProtectedRoute><Layout layoutDisabled><AdditionalDetailsPage /></Layout></ProtectedRoute>} />
    <Route path="/bank-details" element={<ProtectedRoute><Layout layoutDisabled><BankPage /></Layout></ProtectedRoute>} />
    <Route path="/" end element={<ProtectedRoute><Layout><MarketsPage /></Layout></ProtectedRoute>} />
    <Route path="/mutual-funds" element={<ProtectedRoute><Layout><MutualFundsPage /></Layout></ProtectedRoute>} />
    <Route path="/mutual-funds/all" element={<ProtectedRoute><Layout><AllMutualFundsPage /></Layout></ProtectedRoute>} />
    <Route path="/mutual-funds/invest/:id" element={<ProtectedRoute><Layout><MutualFundInvestPage /></Layout></ProtectedRoute>} />
    <Route path="/mutual-funds/collection/:collectionName" element={<ProtectedRoute><Layout><CollectionPage /></Layout></ProtectedRoute>} />
    <Route path="/profile" element={<ProtectedRoute><Layout><ProfilePage /></Layout></ProtectedRoute>} />
    <Route path="/contact" element={<ProtectedRoute><Layout><ContactPage /></Layout></ProtectedRoute>} />
    <Route path="/watchlist" element={<ProtectedRoute><Layout><WatchlistPage /></Layout></ProtectedRoute>} />
    <Route path="/positions" element={<ProtectedRoute><Layout><PositionsPage /></Layout></ProtectedRoute>} />
    <Route path="/referral" element={<ProtectedRoute><Layout><ReferralPage /></Layout></ProtectedRoute>} />
    <Route path="/account-details" element={<ProtectedRoute><Layout><AccountDetailsPage /></Layout></ProtectedRoute>} />
    <Route path="/fund-history" element={<ProtectedRoute><Layout><FundHistoryPage /></Layout></ProtectedRoute>} />
    <Route path="/search" element={<ProtectedRoute><Layout><SearchPage /></Layout></ProtectedRoute>} />
    <Route path="/symbol/:symbolName" element={<ProtectedRoute><Layout><SymbolInfoPage /></Layout></ProtectedRoute>} />
    <Route path="/order/:symbolName/:tradeType" element={<ProtectedRoute><Layout><OrderPage /></Layout></ProtectedRoute>} />
    <Route path="/trade" element={<ProtectedRoute><Layout><TradePage /></Layout></ProtectedRoute>} />
    <Route path="/option-chain/:symbol" element={<ProtectedRoute><Layout><OptionChainPage /></Layout></ProtectedRoute>} />
    <Route path="/account-status" element={<ProtectedRoute><Layout layoutDisabled><AccountStatusPage /></Layout></ProtectedRoute>} />
    <Route path="/notifications" element={<ProtectedRoute><Layout><NotificationsPage /></Layout></ProtectedRoute>} />
    <Route path="/support" element={<ProtectedRoute><Layout><SupportPage /></Layout></ProtectedRoute>} />
    <Route path="/legal" element={<ProtectedRoute><Layout><LegalPage /></Layout></ProtectedRoute>} />
  </Routes>
);

function App() {
  return (
    <Router>
      <AlertProvider>
        <AuthProvider>
          <AccountStatusProvider>
            <ThemeProvider>
              <ProgressBarProvider>
                <PriceProvider>
                  <GlobalAlert />
                  <ProgressBar />
                  <AppRoutes />
                </PriceProvider>
              </ProgressBarProvider>
            </ThemeProvider>
          </AccountStatusProvider>
        </AuthProvider>
      </AlertProvider>
    </Router>
  );
}

export default App;
